import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "905539426789";
const WHATSAPP_TEXT = "Merhaba, Kuzey Yapı Hırdavat sitesinden ulaşıyorum. Bilgi almak istediğim konu:";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_TEXT)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-btn"
      aria-label="WhatsApp ile iletişim"
      className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:shadow-xl transition-all group"
    >
      <MessageCircle size={28} className="group-hover:scale-110 transition-transform"/>
      <span className="absolute right-full mr-3 bg-ink-900 text-white text-sm px-3 py-1.5 rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        WhatsApp'tan yaz
      </span>
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
    </a>
  );
}
